var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"coverflow",rawName:"v-coverflow"}],staticClass:"coverflow"},_vm._l((_vm.coverList),function(coverItem,index){return _c('img',{key:index,attrs:{"src":coverItem.cover}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }